<template>
  <div class="flex items-center text-hex-666 text-12px bread-crumb overflow-hidden">
    <span>您所在的位置：</span>
    <span class="iconfont icon-bg-home text-18px cursor-pointer" @click="jump(null)"></span>
    <div v-for="item in breadcumbList" :key="item.id">
      <span class="text-14px">&gt;</span>
      <span class="cursor-pointer" @click="jump(item)">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench-std'
import { treeToOneArray } from '@/assets/js/Common'

const columnApi = new ColumApi()
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      columnData: [],
      breadcumbList: [],
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val) && val.dataSource !== oldVal?.dataSource) {
          this.breadcumbList = []
          this.getBreadcumb(val.dataSource)
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0, {
        isExistPage: true,
      })
      if (!err) {
        this.columnData = treeToOneArray(res, 'child')
      }
    },
    getBreadcumb(id) {
      if (this.columnData.length === 0) {
        setTimeout(() => {
          this.getBreadcumb(id)
        }, 500)
        return
      }
      const column = _.find(this.columnData, { id })
      if (column) {
        this.breadcumbList.unshift({
          name: column.name,
          id: column.id,
          existPage: column.existPage,
        })
        if (column.parentId) {
          this.getBreadcumb(column.parentId)
        }
      }
    },
    jump(column) {
      if (this.mode === 'update' || (column && !column.existPage)) return
      const query = {}
      if (column?.id) {
        query.columnId = column.id
      }
      this.$router.push({
        path: `${this.routerBase}/integration/portal/homepage`,
        query,
      })
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style lang="scss" scoped></style>
